<script lang="ts">
  import { appStore } from "$app/store.svelte"
  import CircleProgressBar from "$app/components/CircleProgressBar.svelte"

  interface Props {
    course: CourseType
    course_progresses: CourseProgressType[]
    purchased_courses: CoursePurchaseType[]
  }
  let props = $props()
  let { course, course_progresses, purchased_courses }: Props = props

  let purchased = purchased_courses.some(
    (purchased_course) => purchased_course.id === course.id
  )

  let course_progress = course_progresses.find(
    (cp) => cp.course_id === course.id
  )

  const course_img = new URL(
    `/images/courses/e${course.id}_sm.jpg`,
    import.meta.url
  ).href
</script>

{#if course.enabled}
  <a
    href="/plans/{appStore.plan.id}/courses/{course.slug}"
    class="relative pt-64 pb-10 rounded-2xl shadow-xl overflow-hidden"
    style="background-image: url({course_img}); background-size: cover; background-repeat: no-repeat;"
  >
    {#if !purchased}
      <div
        class="absolute top-5 right-4 bg-white w-14 h-14 flex justify-center items-center rounded-lg shadow-lg"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-10 w-10 text-red-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
    {:else if course_progress && course_progress?.percent_progress === 100}
      <div class="absolute top-8 left-4 bg-gray-800 opacity-90 rounded-full">
        <span class="bg-green-500 text-white rounded-lg py-1 px-2 font-bold"
          >COMPLETED</span
        >
      </div>
    {:else if course_progress && course_progress?.percent_progress > 0}
      <div class="absolute top-4 left-3 bg-gray-800 opacity-90 rounded-full">
        <CircleProgressBar progress={course_progress.percent_progress} />
      </div>
    {:else}
      <div class="absolute top-8 left-4 bg-gray-800 opacity-90 rounded-full">
        <span class="bg-red-500 text-white rounded-lg py-1 px-2 font-bold"
          >NOT STARTED</span
        >
      </div>
    {/if}
    <div class="relative px-8">
      <div></div>
      <div class="mt-8">
        <div
          class="relative py-4 md:flex-grow rounded justify-center rounded bg-gray-800 opacity-80"
        >
          <p class="text-center text-2xl font-medium text-white">
            {course.name}
          </p>
        </div>
      </div>
    </div>
  </a>
{:else}
  <div
    class="relative pt-60 pb-10 rounded-2xl shadow-xl overflow-hidden bg-gray-800 opacity-60"
  >
    <img
      src={course_img}
      class="absolute inset-0 h-full w-full object-cover"
      alt={course.name}
    />
    <div
      class="absolute top-5 right-4 bg-white py-2 px-4 flex justify-center items-center rounded-lg shadow-lg"
    >
      <p class="mr-1 text-blue-700 font-bold">Coming Soon</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-10 w-10 text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>
    <div class="relative px-8">
      <div class="mt-8">
        <div
          class="mt-12 relative py-4 rounded justify-center rounded bg-black opacity-90"
        >
          <p class="text-center text-2xl font-medium text-white">
            {course.name}
          </p>
        </div>
      </div>
    </div>
  </div>
{/if}
